// Module
var code = "<mm-card caption=\"'Gui.Common.LanguageLocaleTimezone'\" sub-caption=\"'Gui.Common.LanguageLocaleTimezoneFormat' | translate : $ctrl.localizationStrings\" icon=\"'language'\" edit=\"$ctrl.editLanguage()\" is-loading=\"$ctrl.languages.isLoading\"></mm-card> ";
// Exports
var _module_exports = code;;
var path = '/App/Modules/Auth/Components/Profile/Localization/ProfileLocalization.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;